"use client";

import { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
  Chip,
  Select,
  MenuItem,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  LinearProgress,
  Menu,
  Divider,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  CalendarMonth as CalendarIcon,
  CheckCircle as CheckCircleIcon,
  Warning as AlertTriangleIcon,
  FileText as FileTextIcon,
  Build as WrenchIcon,
  Close as CloseIcon,
  Print as PrinterIcon,
  KeyboardArrowDown,
  Check,
} from "@mui/icons-material";
import { InspeccionPage } from "./Tabs/InspeccionPage";
import Navbar from "../../../Navbar";
import Footer4 from "../../../Footer4";
import { HistorialPage } from "./Tabs/HistorialPage";
import ResumenPage from "./Tabs/ResumenPage";
import useMatafuegos from "../../hooks/useMatafuegos";
import axios from "axios";
import { UrlApi } from "../../../../services/apirest";

// Equivalente a lucide-react, se importan los iconos de MUI
// import { CalendarIcon, CheckCircle2, AlertTriangle, FileText, Wrench, X, Printer } from "lucide-react";

export default function FireExtinguisherInspection() {
  const [plantas, setPlantas] = useState([]);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(
    plantas.length > 0 ? plantas[0].id_planta : null
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const [activeTab, setActiveTab] = useState(0);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePlantSelect = (value) => {
    const newValue = value === plantaSeleccionada ? plantaSeleccionada : value;
    setPlantaSeleccionada(newValue);
    handleClose();
  };
  const getPlantas = useCallback(async () => {
    await axios
      .get(UrlApi + "/mp_equipos/plantas")
      .then((res) => {
        const suc_auth = localStorage.getItem("suc_auth");
        if (!suc_auth) {
          console.log("No hay suc_auth en localStorage");
          return;
        }

        const storedIdsNumbers = suc_auth
          .split(",")
          .map((id) => parseInt(id.trim(), 10));

        const filteredData = res.data.filter(
          (item) => storedIdsNumbers.includes(parseInt(item.id_planta, 10)) // Aseguramos que id_planta sea un número
        );

        setPlantas(filteredData); // Guarda los datos filtrados en el estado
      })
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    getPlantas();
  }, [getPlantas]);

  return (
    <Box sx={{ maxWidth: "1280px", margin: "auto", padding: 3 }}>
      <Navbar />
      <Footer4 />
      <Box sx={{ mb: 4 }}>
        {/* Título */}
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: "bold", mb: 1 }}
        >
          Sistema de Inspección de Matafuegos
        </Typography>

        {/* Subtítulo */}
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Complete las inspecciones mensuales y consulte el historial de
          verificaciones
        </Typography>

        {/* Selector de planta estilizado */}
        <Button
          variant="outlined"
          onClick={handleClick}
          endIcon={<KeyboardArrowDown />}
          sx={{
            justifyContent: "space-between",
            px: 2,
            py: 1,
            borderRadius: 2,
            textTransform: "none",
            fontSize: "0.95rem",
            // Responsive → ocupa todo el ancho en mobile, pero limitado en desktop
            width: { xs: "100%", sm: "300px" },
          }}
        >
          {plantaSeleccionada
            ? plantas.find((plant) => plant.id_planta === plantaSeleccionada)
                ?.sucursal || "Sucursal no encontrada"
            : "Seleccionar planta..."}
        </Button>

        {/* Menú desplegable */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{ sx: { borderRadius: 2, minWidth: 250 } }}
        >
          {plantas.length > 0 ? (
            plantas.map((plant) => (
              <MenuItem
                key={plant.id_planta}
                selected={plantaSeleccionada === plant.id_planta}
                onClick={() => handlePlantSelect(plant.id_planta)}
              >
                {plantaSeleccionada === plant.id_planta && (
                  <Check fontSize="small" sx={{ mr: 1 }} />
                )}
                {plant.sucursal}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>
              <Typography variant="body2" color="text.secondary">
                No se encontraron plantas.
              </Typography>
            </MenuItem>
          )}
        </Menu>
      </Box>
      {/* Contenedor de Tabs */}
      <Box sx={{ width: "100%" }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          aria-label="Componente de inspección"
        >
          <Tab label="Inspección Actual" />
          <Tab label="Historial de Inspecciones" />
          <Tab label="Resumen Imprimible" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {activeTab === 0 && <InspeccionPage plantaId={plantaSeleccionada} />}

          {activeTab === 1 && <HistorialPage plantaId={plantaSeleccionada} />}

          {activeTab === 2 && <ResumenPage plantaId={plantaSeleccionada} />}
        </Box>
      </Box>
    </Box>
  );
}
